<div class="root">
  <div class="content-container container">
    <button
      *ngIf="!isDesktop"
      class="mobile-menu-button"
      type="button"
      data-bs-toggle="collapse"
      data-bs-target="#navbarSupportedContent"
      aria-controls="navbarSupportedContent"
      aria-expanded="false"
      aria-label="Toggle navigation"
    >
      <app-lucide-icon [iconName]="'menu'"></app-lucide-icon>
    </button>

    <h1
      class="title"
      [routerLink]="[appRoutes.home.url]"
    >Portal do <span class="highlight-text">Segurado</span></h1>

    <app-user-menu></app-user-menu>
  </div>
</div>
